import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

function RowActionsMenu({
  actions = [],
  trigger,
  menuClassName = 'submenu',
  menuProps = {},
  ariaLabel = 'Open row actions',
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const visibleActions = actions.filter((action) => action?.visible !== false);

  if (visibleActions.length === 0) {
    return null;
  }

  const defaultTrigger = (
    <span
      className="icon-more"
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={handleOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleOpen(event);
        }
      }}
    ></span>
  );

  return (
    <>
      {typeof trigger === 'function' ? trigger({ onOpen: handleOpen }) : defaultTrigger}
      <Menu
        className={menuClassName}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        {...menuProps}
      >
        {visibleActions.map((action) => (
          <MenuItem
            key={action.key}
            disabled={Boolean(action.disabled)}
            className={action.className || ''}
            onClick={() => {
              if (action.disabled) {
                return;
              }
              action.onClick?.();
              handleClose();
            }}
          >
            {action.label}
            {action.trailingContent || null}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default RowActionsMenu;
